<template>
  <div>
    <v-btn
      absolute
      flat
      right
      @click="dialog = true"
      style="top: 10px; background-color: #fddf00; width: 170px; height: 40px"
    >
      <v-icon color="black" style="font-size: 35px">add</v-icon>
      <h3>SET COMMISSION</h3>
    </v-btn>
    <newUserDialog
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
      @onSaved="addUser($event)"
    ></newUserDialog>
    <editCommission
      :selectedItem="selectedItem"
      :originalUser="originalUser"
      :editDialog="editDialog"
      @setDialog="editDialog = $event"
      @setOriginal="originalUser = $event"
      @onSaved="editUser($event)"
    ></editCommission>
    <v-toolbar dense flat>
      <v-layout row>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search province / district"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filteredcommissionlist"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{
            pagination.page * pagination.rowsPerPage -
              (pagination.rowsPerPage - props.index - 1)
          }}
        </td>
        <td class="text-xs-center">
          {{
            props.item.commission_area_province.commission_area_province_name
          }}
        </td>

        <td class="text-xs-center">
          {{
            props.item.commission_area_district.commission_area_district_name
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_extra_transport_price }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_gp }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_fee_delivery }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_promotion }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_fee_delivery_differentail }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_guarantee_fee }}
        </td>
        <td class="text-xs-center">
          {{ props.item.commission_area_small_order_price }}
        </td>
        <td>
          <v-btn
            :to="
              `/weserve_admin_login/-/CommissionArea/${
                props.item.commission_area_id
              }`
            "
            icon
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
          <v-btn icon @click="editItem(props.item)"
            ><v-icon small>edit</v-icon>
          </v-btn>
          <v-btn icon @click="toDeleteItem(props.item)" :loading="isDeleting">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="deleteDialog" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title class="px-4"
          ><h2>Are you want to delete this commission area?</h2>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="pr-5 py-4">
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            color="red"
            style="
                  width: 120px;
                  border-radius: 7px;
                  font-weight: bold;
                  font-size: 16px;
                "
            @click="deleteDialog = false"
            :loading="changingPassword"
            >cancel</v-btn
          >
          <v-btn
            flat
            dark
            color="black"
            style="
                  width: 120px;
                  background-color: #fddf00;
                  border-radius: 7px;
                  font-weight: bold;
                  font-size: 16px;
                "
            @click="deleteItem()"
            :loading="changingPassword"
            >confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import newUserDialog from "./Popupcommission.vue";
import editUserDialog from "./EditUser.vue";
import editCommission from "./EditCommission.vue";
export default {
  data: () => ({
    currentPage: 1,
    pageItems: 10,
    valid: false,
    show1: false,
    show2: false,
    changingPassword: false,
    deleteDialog: false,
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    selectedItem: {
      commission_area_id: "",
      commission_area_province_name: "",
      commission_area_district_name: "",
      commission_area_extra_transport_price: "",
      commission_area_gp: "",
      commission_area_fee_delivery: "",
      commission_area_promotion: "",
      commission_area_small_order_price: "",
    },
    dialog: false,
    editDialog: false,
    originalUser: null,
    isDeleting: false,
    headers: [
      {
        text: "No.",
        value: "commission_area_id",
        sortable: false,
        align: "center",
      },
      {
        text: "Province",
        value: "commission_area_province_name",
        sortable: false,
        align: "center",
      },
      {
        text: "District",
        sortable: false,
        value: "commission_area_district_name",
        align: "center",
      },
      {
        text: "Extra Transport Price(%)",
        sortable: false,
        value: "commission_area_extra_transport_price",
        align: "center",
      },
      {
        text: "GP(%)",
        value: "commission_area_gp",
        sortable: false,
        align: "center",
      },
      {
        text: "Fee Delivery(%)",
        value: "commission_area_fee_delivery",
        sortable: false,
        align: "center",
      },
      {
        text: "Promotion(%)",
        value: "commission_area_promotion",
        sortable: false,
        align: "center",
      },
      {
        text: "Additional Fee(%)",
        value: "commission_area_fee_delivery_differentail",
        sortable: false,
        align: "center",
      },
      {
        text: "Guarantee Fee(%)",
        value: "commission_area_guarantee_fee",
        sortable: false,
        align: "center",
      },
      {
        text: "Small Order(%)",
        value: "commission_area_small_order_price",
        sortable: false,
        align: "center",
      },
      {
        text: "Actions",
        value: "",
        align: "center",
        sortable: false,
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    newUserDialog,
    editUserDialog,
    editCommission,
  },
  computed: {
    ...mapState({
      indexEditLoading: (state) => state.fetchUserBack.indexEditLoading,
      userData: (state) => state.fetchUserBack.userData,
      commissionlist: (state) => state.fetchCommission.commissionlist,
    }),
    ...mapMutations({
      getDataCommission: "fetchCommission/getDataCommission",
    }),
    ...mapGetters(["isEditStaff"]),

    filteredcommissionlist() {
      return this.commissionlist.filter((val) =>
        (
          val.commission_area_province.commission_area_province_name +
          " " +
          val.commission_area_district.commission_area_district_name
        )
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    editItem(item) {
      let userItem = JSON.parse(JSON.stringify(item));
      console.log(userItem);
      this.selectedItem = userItem;
      this.editDialog = true;
    },
    toDeleteItem(item) {
      this.deleteDialog = true;
      this.selectedItem = JSON.parse(JSON.stringify(item));
    },
    async deleteItem() {
      this.isDeleting = true;
      let result = await this.$store.dispatch(
        "fetchCommission/deleteCommission",
        this.selectedItem.commission_area_id
      );
      this.isDeleting = false;
      if (result == false) return;
      let index = this.commissionlist.findIndex(
        (val) => val.commission_area_id == this.selectedItem.commission_area_id
      );
      this.commissionlist.splice(index, 1);
      this.deleteDialog = false;
    },
    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("fetchCommission/fetchManagerCommission");
      this.loadingMessage = false;
    },
    async addUser(payload) {
      let result = await this.$store.dispatch(
        "fetchCommission/addCommission",
        payload.form
      );
      payload.done();
      if (result === true) {
        this.dialog = false;
        this.getData();
      } else {
        alert("มีบางอย่างผิดพลาด");
      }
    },

    async editUser(payload) {
      console.log(payload);
      let result = await this.$store.dispatch(
        "fetchCommission/editCommission",
        payload.form
      );
      payload.done();
      if (result === true) {
        this.editDialog = false;
        this.getData();
      } else {
        alert("มีบางอย่างผิดพลาด");
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.body__district::-webkit-scrollbar {
  display: none;
  max-height: 150px;
  overflow: auto;
}
</style>
